// src/components/CustomFields/ProgramField.js
import React, { useEffect, useState } from "react";
import { dbGet } from "utils/DBFetchers";
import SelectField from "./SelectField";

import useStyles from "./styles";

export default function ProgramsField(props) {
  var classes = useStyles();
  const [allPrograms, setAllPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([
    { id: 1, name: "Receta solidaria" },
    { id: 2, name: "Solo mujer" },
  ]);

  const filterPrograms = (data) => {
    var filteredData = data.map((program) => {
      if (props.auditNames && program.id === 1) {
        return { ...program, name: "Receta Solidaria Tradicional" };
      }
      return program;
    });
    if (props.GES === false) {
      filteredData = filteredData.filter((program) => program.name !== "GES");
    }
    if (props.Salco === false) {
      filteredData = filteredData.filter(
        (program) => program.name !== "Mi Salcobrand",
      );
    }
    if (props.burnable) {
      filteredData = [
        ...filteredData,
        {
          id: 1000,
          name: props.auditNames ? "Receta Solidaria Quemables" : "Quemables",
        },
      ];
    }

    if (props.cronicosAhumada) {
      filteredData = [
        ...filteredData,
        {
          id: 5,
          name: "Crónicos Ahumada",
        },
      ];
    }
    if (props.clubPlusCV) {
      filteredData = [
        ...filteredData,
        {
          id: 6,
          name: "Club + Cruz Verde",
        },
      ];
    }
    setFilteredPrograms(filteredData);
  };

  useEffect(() => {
    if (allPrograms.length) filterPrograms(allPrograms);
  }, [props.GES, props.Salco]);

  useEffect(() => {
    dbGet("/programs")
      .then((data) => {
        setAllPrograms(data);
        filterPrograms(data);
      })
      .catch((error) => { });
  }, []);

  return (
    <SelectField
      divClassName={props.divClassName}
      fieldClassName={props.fieldClassName}
      displayText={props.displayText}
      id="programs"
      label="Seleccione"
      name="program"
      value={props.value}
      onChange={props.onChange}
      allValues={filteredPrograms ? filteredPrograms : []}
      disabled={props.disabled || false}
    />
  );
}
